module.exports = __webpack_public_path__ + "img/knc.976f2482.svg";